import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Singleton pattern to prevent multiple instances
let supabaseInstance: SupabaseClient<Database> | null = null;

// Função para criar uma única instância do Supabase
function createSupabaseInstance(): SupabaseClient<Database> {
  if (supabaseInstance) {
    return supabaseInstance;
  }

  supabaseInstance = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
      storageKey: 'bufunfa-auth-token', // Chave única para evitar conflitos
    },
    global: {
      fetch: (url, options = {}) => {
        return fetch(url, {
          ...options,
          // Add retry logic and better error handling
          signal: AbortSignal.timeout(30000), // 30 second timeout
        }).catch((error) => {
          console.error('Supabase fetch error:', error);
          // Return a rejected promise with a more descriptive error
          if (error.name === 'AbortError') {
            throw new Error('Request timeout - please check your internet connection');
          }
          if (error.message.includes('Failed to fetch')) {
            throw new Error('Network error - please check your internet connection and try again');
          }
          throw error;
        });
      },
    },
  });

  return supabaseInstance;
}

// Exportar a instância única
export const supabase = createSupabaseInstance();
